import { Factory, Zap, Building2, Signal, TrainFront, ArrowUpRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { scrollToSection } from "@/App";

const INDUSTRIES = [
  { icon: Zap, label: "Power & Substations" },
  { icon: Factory, label: "Industrial Plants" },
  { icon: Building2, label: "Commercial Buildings" },
  { icon: Signal, label: "Telecom & Data" },
  { icon: TrainFront, label: "Infrastructure & Rail" },
];

export const Industries = () => {
  return (
    <section data-testid="industries-section" className="relative bg-ink py-16 md:py-20 border-t border-white/10">
      <div className="max-w-[1440px] mx-auto px-5 md:px-10">
        <Reveal>
          <p className="font-mono text-[10px] md:text-xs tracking-[0.35em] uppercase text-smoke text-center mb-10">
            Industries We Serve
          </p>
        </Reveal>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-5">
          {INDUSTRIES.map((it, i) => (
            <Reveal key={it.label} delay={i * 0.06}>
              <div className="group bg-steel border border-white/10 hover:border-[#7FB3E8]/40 p-6 text-center transition-colors duration-300">
                <it.icon size={26} className="mx-auto text-[#7FB3E8]" strokeWidth={1.5} />
                <p className="mt-3 font-heading font-semibold uppercase text-base tracking-wide text-white">
                  {it.label}
                </p>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.15}>
          <div className="mt-14 md:mt-16 bg-gradient-to-r from-royal to-steel border border-white/10 px-7 md:px-12 py-10 md:py-12 flex flex-col md:flex-row md:items-center md:justify-between gap-6">
            <div>
              <h3 className="font-heading font-semibold uppercase text-2xl md:text-3xl tracking-wide text-white">
                Need trays for an ongoing project?
              </h3>
              <p className="mt-2 font-body text-sm text-white/70">
                Share your schedule today — priced quote within 24 working hours.
              </p>
            </div>
            <button
              data-testid="cta-band-button"
              onClick={() => scrollToSection("#contact")}
              className="btn-sweep btn-solid font-heading font-semibold uppercase tracking-wider text-lg px-8 py-3 flex items-center gap-2 shrink-0 w-fit"
            >
              Get a Quote <ArrowUpRight size={18} />
            </button>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
